module.exports = __webpack_public_path__ + "static/img/编组 5备份 9.a38535c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hz/编组 5备份 9.png
// module id = lqFg
// module chunks = 1